import React, { useEffect, useRef } from 'react';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Collapse, Tooltip, Zoom } from '@material-ui/core';
import { Button, Container, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import CardMedia from '@mui/material/CardMedia';
import { Link as LinkIcon, Close, Assignment } from '@material-ui/icons';
import borda from './../assets/images/comum/photo_profile.png'
import CloudUpload from '@material-ui/icons/CloudUpload';

import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import QrCode from '@mui/icons-material/QrCode';
import ViewHeadline from '@mui/icons-material/ViewHeadline';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import { connect, ConnectedProps } from 'react-redux';
import store from '../redux/store';
import { getUsuarios, deleteUsuario, createUsuario, updateUsuario } from '../redux/usuarios/actions';
import { setUser } from '../redux/user/actions';
import { getAllInventoryStart, consultProductStart, getInventoriesByCategory, getInventoriesByFilter } from '../redux/produtos/actions';

import { fetchEmpresas, } from '../redux/empresas/actions';
import { getImagesByReferencia, } from '../redux/referencias/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/Help';

import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AssessmentIcon from '@mui/icons-material/Assessment';

import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, ExpandLess, ViewList, Link } from '@material-ui/icons';
import { green } from '@material-ui/core/colors';
import { Autocomplete, ButtonGroup, Card, CardActions, CardContent, CardHeader, Divider, FormControlLabel, FormGroup, LinearProgress, ListItemButton, ListSubheader, Stack, Switch, useMediaQuery, useTheme } from '@mui/material';
import moment from 'moment'
import { VictoryBar, VictoryPie } from 'victory';
import { client, AUTH_USER, getUsers, whoami, UPDATE_USER, CREATE_USER, filterUser, getCategories, findProfileByUser, CREATE_RECOMMENDATION, filterChatgpt, AI_URL_FEEDBACK, TOGGLE_FAVORITE } from '../graphqlClient/graphql'
import { animate, createScope, createSpring, createDraggable } from 'animejs';

import Box from '@mui/material/Box';
import {
  useGridApiRef,
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbar,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridValueGetterParams,
  GridToolbarExport,
} from '@mui/x-data-grid';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { serverConfig } from '../api/apiConfig';

// Core viewer
import { Viewer, Worker } from '@react-pdf-viewer/core';

// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useMutation } from '@apollo/client';
import Notifications from '../components/notifications/Notifications';
import planetPulse from 'planetpulse';
import { ClearIcon } from '@mui/x-date-pickers';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    textAlign: 'center',
    minWidth: '100%',
    maxWidth: '1200',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    //alignItems: 'center',
    height: '100%',
  },
  content: {
    width: '100%',
    textAlign: 'center',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between!important',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  deleteButton: {
    marginLeft: theme.spacing(1),
  },
  addButton: {
    margin: theme.spacing(1),
    backgroundColor: green[500],
    color: 'white',
    '&:hover': {
      backgroundColor: green[700],
    },
  },

  listContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: theme.spacing(3),
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 100px)',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'green',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'darkgreen',
    },
  },
  card: {
    width: 345,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    userSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[10],
    },
  },
  cardContent: {
    flexGrow: 1,
    minHeight: 120,
    maxHeight: 120,
    overflow: 'hidden',
    userSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    '& .custom-scrollbar': {
      '&::-webkit-scrollbar': {
        width: '4px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 128, 0, 0.3)',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: 'rgba(0, 128, 0, 0.5)',
      },
    },
  },
  irButton: {
    margin: 5
  }
}));

const chartConfig = {
  backgroundColor: '#26872a',
  backgroundGradientFrom: '#43a047',
  backgroundGradientTo: '#66bb6a',
  color: (opacity = 1) => `#ffffff`,
  style: {
    borderRadius: 16
  }
};

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const workerUrl = new URL(
  'https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js',
  import.meta.url,
).toString();

type PropsFromRedux = ConnectedProps<typeof connector>;

const ScoutingPoolPage: React.FC<PropsFromRedux> = ({ usuario, setUser }) => {
  let newKeyword = ''
  const allCountries = planetPulse.getAllCountries();
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const screenWidth: any = getWindowDimensions().width
  const screenHeight: any = getWindowDimensions().height
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [favoriteFeedback, setFavoriteFeedback] = React.useState<any>(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
  const [selectedUsuario, setSelectedUsuario] = React.useState('');
  const [messageToScout, setMessageToScout] = React.useState('');
  const [joblink, setJoblink] = React.useState('');

  const [editUsuarioData, setEditUsuarioData] = React.useState<any>({});
  const [newUsuarioPermissoes, setNewUsuarioPermissoes] = React.useState<any>({});
  const [editUsuarioModalOpen, setEditUsuarioModalOpen] = React.useState(false);
  const [passwordOpen, setPasswordOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [category, setCategory] = React.useState('');
  const [selectedItem, setSelectedItem] = React.useState<any>({});
  const [categoriesToShow, setCategoriesToShow] = React.useState([{ nome: 'Todas', _id: 0 }]);

  const [total, setTotal] = React.useState<any>(0);
  const [dataChart, setDataChart] = React.useState<any>([]);
  const [visible, setVisible] = React.useState(false);
  const [openAiFeedbackModal, setOpenAiFeedbackModal] = React.useState(false);
  const [progress, setProgress] = React.useState(10);
  const [limit, setLimit] = React.useState(0);
  const permissoesList = ['administrador', 'gerente', 'basico']
  const [rows, setRows] = React.useState<any>([]);
  const [users, setUsers] = React.useState<any>([]);
  const [categories, setCategories] = React.useState<any>([]);
  const [favorites, setFavorites] = React.useState<string[]>([]);
  const [showOnlyFavorites, setShowOnlyFavorites] = React.useState(false);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
  const [selectedCategory, setSelectedCategory] = React.useState<any>({ key: 0, value: 'Filtro por unidade' });
  const [selectedGrade, setSelectedGrade] = React.useState<any>(null);
  const [selectedLocation, setSelectedLocation] = React.useState<any>({});
  const [selectedKeywords, setSelectedKeywords] = React.useState<any>('');
  const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });
  const [selectedProduto, setSelectedProduto] = React.useState<any>({ key: 0, value: 'Filtro por produto' });
  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  const [expanded, setExpanded] = React.useState('');
  const [openPdf, setOpenPdf] = React.useState(false);
  const [selectedScout, setSelectedScout] = React.useState<any>({});
  const [scoutInfo, setScoutInfo] = React.useState<any>(false);
  const [showJob, setShowJob] = React.useState<any>(false);
  const [openModalRecomendation, setOpenModalRecomendation] = React.useState<any>(false);
  const [link, setLink] = React.useState('');
  const [image, setImage] = React.useState<any>('');
  const [svg, setSvg] = React.useState<any>('');
  const [chatgpt, setChatgpt] = React.useState<any>([]);
  const [airesumefeedbackData, setAiresumefeedbackData] = React.useState<any>(null);
  const [defaultPdf, setDefaultPdf] = React.useState<any>('');
  const [urlResult, setUrlResult] = React.useState<any>({});
  const [result, setResult] = React.useState<any>('');
  const [finalResult, setFinalResult] = React.useState<any>('');
  const myRef = useRef(null);
  const scope = useRef<any>(null);
  //
  useEffect(() => {
    if (myRef.current) {
      animate(
        myRef.current, {
        translateY: [10, 0],
        opacity: [0, 1],
        duration: 1000,
      });
    }
  }, []);
  //
  const handleExpandClick = (id: string) => {
    const newValue = expanded == id ? '' : id
    setExpanded(newValue);
  };
  const apiRef = useGridApiRef();

  const [CreateRecommendationMutation, { data }] = useMutation(CREATE_RECOMMENDATION);
  const [AiUrlFeedback, { data: aiUrl }] = useMutation(AI_URL_FEEDBACK);
  const handleAddRecommendationPanel = async (scout: any) => {
    setSelectedScout(scout)
    setOpenModalRecomendation(true)

  }
  const handleAddRecommendation = async () => {
    setLoading(true);
    console.log('usuario', usuario)
    console.log('scout', selectedScout)

    const dataToSend = {
      scouter: usuario._id,
      scout: selectedScout._id,
      active: true,
      company: usuario.company._id,
      link: joblink,
      status: 'Under Review',
      details: 'Need your action',
      detailsScouter: 'Under Review by candidate',
      type: 'scoutingpool',
      message: messageToScout || '',

    }
    console.log('dataToSend', dataToSend)
    setOpenModalRecomendation(false)
    // dataToSend.id = dataToSend._id


    try {

      const createRecommendationInput = dataToSend
      console.log('createRecommendationInput', dataToSend)

      const result = await CreateRecommendationMutation({
        variables: {
          createRecommendationInput
        },
        onCompleted: ({ createRecommendation }) => {

          console.log(' created== > ', createRecommendation);
          const notData = {
            type: 'success',
            message: `Recommendation to ${createRecommendation?.company?.name} Created Successfully!`,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }

          Notifications(notData)
          setLoading(false);
          //setSelectedCompany({})
          //navigate('/scout')
          //setCompany(updateUser);
        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      console.log("Error at create credit", error)

    }

  };

  const getUsersAsync = async () => {
    setLoading(true)
    const profile: any = {}
    const objToSend: any = {
      //startDate,
      //endDate,
      //empresa:empresa
      role: 'scout',
      confirmed: true,
      enableScoutingPool: true,
      //usuario : selectedUser?._id || '',
    }
    if (selectedCategory) {
      objToSend.category = selectedCategory._id
    }
    if (selectedKeywords) {
      objToSend.keywords = selectedKeywords.toLowerCase()
    }
    if (newKeyword) {
      objToSend.keywords = newKeyword.toLowerCase()

    }
    if (selectedLocation.name) {
      profile.location = selectedLocation.name
      objToSend.profile = profile
    }
    if (selectedGrade !== null) {
      objToSend.grade = selectedGrade.toString()
    }
    //setIsLoadingCompaniesByFilter(true)
    console.log('objToSend', objToSend)

    const result = await filterUser(objToSend)
    console.log('filter users result ==>>', result)

    if (Array.isArray(result)) {
      let finalUsers = result;
      if (selectedGrade !== null) {
        finalUsers = result.filter((u: any) => (u.grade || 0) >= selectedGrade);
      }
      setUsers(finalUsers)
    } else {
      console.error('filterUser did not return an array:', result)
      setUsers([])
    }
    newKeyword = ''
    setLoading(false)

  }
  const getCategoriesAsync = async () => {

    const result: any = await getCategories()
    console.log('categories ===>', result)

    if (result?.length) {
      setCategories(result)
    }
    return result;
  }




  useEffect(() => {
    if (usuario && usuario.favorites) {
      setFavorites(usuario.favorites);
    }
  }, [usuario]);

  const handleToggleFavorite = async (targetUserId: string) => {
    try {
      const result: any = await client.mutate({
        mutation: TOGGLE_FAVORITE,
        variables: { targetUserId },
      });
      if (result.data.toggleFavorite) {
        const newFavorites = result.data.toggleFavorite.favorites;
        setFavorites(newFavorites);
        // Sync with Redux
        const newUser = { ...usuario, favorites: newFavorites };
        setUser(newUser);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
    }
  };

  useEffect(() => {
    //changeFilter()
    getUsersAsync()
  }, [selectedUser, selectedCategory, selectedGrade, selectedProduto, startDate, endDate, selectedLocation]);
  useEffect(() => {
    //changeFilter()
    console.log('selectedKeywords', selectedKeywords)
    if (selectedKeywords == '') {
      getUsersAsync();
    }
  }, [selectedKeywords]);


  useEffect(() => {
    getUsersAsync()
    getCategoriesAsync()
  }, []);
  let timer: any
  useEffect(() => {
    console.log('limit useEffect', limit)
    setProgress(limit)

  }, [limit]);
  useEffect(() => {
    console.log('urlResult useEffect', urlResult.jobtitle)


  }, [urlResult]);





  /* useEffect(() => {
      if(inventoriesList.length){
        
        apiRef.current.setColumnVisibility('_id', false);
      }
  }, [inventoriesList]); */



  const handleDeleteClick = (UsuarioId: string) => {
    console.log('UsuarioId', UsuarioId)
    setSelectedUsuario(UsuarioId);
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirmation = () => {
    console.log('selectedUsuario', selectedUsuario)
    deleteUsuario(selectedUsuario);
    setDeleteConfirmationOpen(false);
  };


  const makePermissoes = () => {
    if (newUsuarioPermissoes == 'administrador') {
      return { admin: true }
    } else if (newUsuarioPermissoes == 'basico') {
      return { basic: true }
    } else if (newUsuarioPermissoes == 'gerente') {
      return { manager: true }
    } else {
      return {}
    }
  }






  const handlerSelectedItem = (item: any) => {
    console.log(item, item)
    setSelectedItem(item)



  }

  const getCategoriaNome = (id: any) => {
    const nome = categories.filter((item: any) => id == item._id)
    return nome.length ? nome[0].nome : id

  }




  const clearData = (d: any) => {
    const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
    return dateTransform
  }




  interface Props {
    title: any
    subTitle: any
    itensList: []
    type: any
  }


  function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
  ) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            style={{ color: '#ffffff', fontWeight: 'bold' }}
            variant="caption"
            component="div"

          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }


  const handlerCloseModal = () => {
    setVisible(false)
    setLimit(0)
    setProgress(0)
    clearInterval(timer);
    setFinalResult('')
    setResult('')
    setSelectedScout({})
    setScoutInfo(false)
    setOpenAiFeedbackModal(false)
    setLoading(false)
    setDefaultPdf('')
    setFavoriteFeedback(null)
    setImage('')
  }

  const compare = (a: any, b: any) => {
    if (a.createdAt > b.createdAt)
      return -1
    else if (a.createdAt < b.createdAt)
      return 1
    else
      return 0

  }


  const changeCategoria = (cat: any) => {

    console.log('categoria id: ', cat)

    if (cat == 0) {
      getAllInventoryStart()
    } else {
      //get(cat)
    }

  }


  //init DataGrid dependencies

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  interface EditToolbarProps {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
      newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
    ) => void;
  }

  const _ = (id: GridRowId) => () => {
    setRows(rows.filter((row: any) => row._id !== id));
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row._id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row._id !== id));
    }
  };

  const processRowUpdate: any = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    console.log('newRow', newRow)
    //setEditProdutoData(newRow)
    setRows(rows.map((row: any) => (row._id === newRow._id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };


  const columns: GridColDef[] = [
    { field: '_id', headerName: 'ID', width: 90 },
    {
      field: 'createdAt',
      headerName: 'Data',
      type: 'Date',
      width: 120,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => clearData(params.row.createdAt)
    },
    {
      field: 'categoria',
      headerName: 'Unidade',
      width: 120,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => getCategoriaNome(params.row.categoria)
    },
    {
      field: 'usuario',
      headerName: 'Operador',
      width: 120,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.usuario?.nome
    },

    {
      field: 'quantidade',
      headerName: 'Quantidade',
      type: 'number',
      width: 90,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => params.row.conteudo.productsByCategory.length
    },
    {
      field: 'resultado',
      headerName: 'Resultado',
      type: 'number',
      width: 90,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => (Math.round((params.row.conteudo.progress || 1) * 100)) + '%'
    },

    {
      field: 'identificados',
      headerName: 'Identificados',
      type: 'number',
      width: 90,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => ((params.row.conteudo.tagsEquals.length || 1))
    },
    {
      field: 'tagsLost',
      headerName: 'Nâo encontrados',
      type: 'number',
      width: 90,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => ((params.row.conteudo.tagsLost.length || 0))
    },
    {
      field: 'notfound',
      headerName: 'Externos',
      type: 'number',
      width: 80,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => ((params.row.conteudo.tagsNotFound.length || 0))
    },
    {
      field: 'lidos',
      headerName: 'Lidos',
      type: 'number',
      width: 80,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => ((params.row.conteudo.tagsFound.length || 1))
    },
    /* {
      field: 'identificacao',
      headerName: 'código',
      description: 'código do item',
      sortable: false,
      width: 140,
      valueGetter: (params: GridValueGetterParams) =>
        `${params.row.identificacao[0].codigo || ''}  `,
    }, 
    {
      field: 'updatedAt',
      headerName: 'tipo identificacao',
      description: 'tipo de identificacao',
      sortable: false,
      width: 75,
      valueGetter: (params: GridValueGetterParams) =>
        `${params.row.identificacao[0].tipo || ''} `,
    }, */
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Ações',
      width: 150,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        //const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const inventory = categories.filter((item: any) => item._id == id)[0]
        return [

          <GridActionsCellItem
            icon={<Tooltip TransitionComponent={Zoom} title="Relatório" arrow>
              <IconButton className='iconDetail' color="primary" aria-label="Relatório" >
                <ViewHeadline />
              </IconButton>
            </Tooltip>}
            label="Relatório"
            className="textPrimary"
            onClick={() => handlerSelectedItem(inventory)}
            color="inherit"
          />,

        ];
      },
    },


  ];

  const hiddenFields = ['_id', 'id', 'ID'];

  const getTogglableColumns = (columns: GridColDef[]) => {
    console.log('getTogglableColumns', columns)
    return columns
      .filter((column) => !hiddenFields.includes(column.field))
      .map((column) => column.field);
  };

  interface AutocompleteOption {
    categoria: string;
  }

  const changeFilter = () => {
    setLoading(true)

    const objToSend = {
      startDate,
      endDate,

      //categoria:selectedCategory?._id || '',

    }
    console.log('objToSend', objToSend)
    //getInventoriesByFilter(objToSend)
    setLoading(false)

  }

  /* useEffect(() => {
    if(editUsuarioData.flag){
      fetch(editUsuarioData.flag)
        .then(res => res.text())
        .then(setSvg)
        .catch()
        .then(() => console.log('leu o svg'))
    }
}, [editUsuarioData.flag]); */
  useEffect(() => {
    let resultObj
    let final = ''
    if (result) {
      makeFinalResult(result)
    }
  }, [result]);
  function formatText(inputText: string): string {
    // Substitui quebras de linha por <br>
    const formattedText0 = inputText.replace(/Nota da Avaliação: (\d\/10)/, '<strong>Nota da Avaliação: $1</strong> <br>');
    const formattedText = formattedText0.replace('###', '');
    const formattedText1 = formattedText.replace(': -', ':');
    const formattedText2 = formattedText1.replace('. -', ':');

    // Aplica negrito para o texto entre ** **
    const boldText = formattedText2.replace(/\*\*(.*?)\*\*/g, '<br><strong>$1</strong>');

    return boldText;
  }

  const makeBullets = (val: any) => {
    let resp = ''
    if (val.length) {
      for (let z = 0; z < val.length; z++) {
        const valor = val[z]
        if (typeof valor != "string") {
          resp += makeBullets(valor) + "<br>"
        } else {
          resp += `* ${valor} <br>`
        }

      }
    } else {
      for (var i in val) {
        const valor = val[i]
        if (typeof valor != "string") {
          resp += "<h3>" + i + "</h3><br>" + makeBullets(valor)
        } else {
          resp += `* ${i}: ${valor} <br>`
        }

      }
    }
    return resp;
  }

  const makeFinalResult = (res: any) => {
    let resObj
    let final = ''
    if (res) {
      resObj = JSON.parse(res)

      let rawGrade = parseFloat(String(resObj.grade));
      let grade = 80;
      if (!isNaN(rawGrade)) {
        if (rawGrade <= 1) rawGrade = rawGrade * 100;
        else if (rawGrade <= 10) rawGrade = rawGrade * 10;
        grade = Math.round(rawGrade);
      }
      setLimit(grade)
      console.log('grade', grade)
      console.log('resObj', resObj)
      if (resObj) {
        for (var i in resObj) {
          if (i === 'grade') continue;
          const valor: any = resObj[i]
          final += '<h3 style="color: #00FFFF; margin-top: 18px; margin-bottom: 8px; font-weight: 600; text-transform: capitalize; border-bottom: 1px solid rgba(138, 46, 226, 0.2); padding-bottom: 4px;">' + i + "</h3>"
          if (typeof valor == 'object') {
            final += makeBullets(valor)

          } else {
            final += valor
          }
          final += '<br>'
        }
      }
      console.log('final', final)
      setFinalResult(final)
      return final
    }

  }

  const getChatgptAsync = async (userResume: any) => {

    const result: any = await filterChatgpt({ user: userResume._id, type: "airesumefeedback" })
    //console.log('resutl ===>', result)

    if (result?.length) {
      setChatgpt(result)

      // Find the favorite/default record
      const defaultRecord = result.find((r: any) => r.isDefault === true)
      // Fallback to the latest record if no default is found
      const activeRecord = defaultRecord || result[result.length - 1]

      const res = activeRecord.response
      setResult(res)
      setAiresumefeedbackData(activeRecord)
      setDefaultPdf(defaultRecord?.pdf || activeRecord.pdf || '')
      setFavoriteFeedback(defaultRecord || null)
    } else {
      setChatgpt([])
      setAiresumefeedbackData(null)
      setDefaultPdf('')
      setResult('')
      setFavoriteFeedback(null)
    }
  }

  const getProfileByUserAsync = async (userId: any) => {
    try {
      setLoading(true)
      console.log('userId', userId)
      const profile: any = await findProfileByUser(userId);
      console.log('profile ==>>', profile)
      setLoading(false)
      setEditUsuarioData(profile)

    }
    catch (error) {
      console.log("Erro no getUser >>>>>", error)
    }
  }

  const handleScoutInfo = async (user: any) => {
    console.log('user', user)
    getChatgptAsync(user)
    await getProfileByUserAsync(user._id)
    //setSelectedRecommendation(recom)
    setSelectedScout(user)
    if (user?.image) {
      const imagePath = serverConfig.dev.url + 'images/' + user.image;
      setImage(imagePath)
    } else {
      setImage('')
    }
    setScoutInfo(true)
    //setRequestPanel(true)
    //handleAddReferral(recom)
    //setRequestPanel(true)
  }

  const handleOpenAiFeedback = async (user: any) => {
    setLoading(true);
    getChatgptAsync(user);
    await getProfileByUserAsync(user._id);
    setSelectedScout(user);
    if (user?.image) {
      const imagePath = serverConfig.dev.url + 'images/' + user.image;
      setImage(imagePath);
    } else {
      setImage('');
    }
    setOpenAiFeedbackModal(true);
    setLoading(false);
  }

  const sendMessage = async () => {

    if (!joblink) {
      const notData = {
        type: 'error',
        message: 'Provide the job link',
        title: 'wescout',
        timeOut: 1000,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      return;
    }
    const message = joblink
    const createChatgptInput: any = {
      user: usuario._id,
      message,
      type: 'aiurlfeedback',
    }

    delete createChatgptInput.__typename
    console.log('createChatgptInput', createChatgptInput)

    setLoading(true)
    try {
      const userToken = await AiUrlFeedback({
        variables: {
          createChatgptInput: createChatgptInput,

        },
        onCompleted: ({ aiurlresumefeedback }) => {

          console.log('aiurlresumefeedback result== > ', aiurlresumefeedback);
          /* const notData = {
              type: 'success',
              message: 'Your resume has been successfully reviewed',
              title: 'wescout',
              timeOut: 1500,
              callback: () => { },
              priority: true,
          }
          Notifications(notData) */
          let res = aiurlresumefeedback.response
          console.log('res', res)
          if (res == 'No response received from the assistant.') {
            const notData = {
              type: 'error',
              message: 'No response received from the assistant',
              title: 'wescout',
              timeOut: 1000,
              callback: () => { },
              priority: true,
            }
            Notifications(notData)
            setLoading(false)
            return;
          }
          console.log("type", typeof res)
          if (typeof res == 'string') {
            try {
              res = JSON.parse(res);
            } catch (e) {
              console.error('Error parsing AI job analysis:', e);
              const notData = {
                type: 'error',
                message: 'Failed to process job description. Please try again.',
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
              }
              Notifications(notData);
              setLoading(false);
              return;
            }
          }
          setUrlResult(res);
          setLoading(false);
          if (res.jobtitle) {
            console.log('res.jobtitle', res.jobtitle)
            const keyword = res.jobtitle
            setSelectedKeywords(keyword)
            newKeyword = keyword
            getUsersAsync()
          }

          //setChatgpt(aiurlresumefeedback)
          //getChatgptAsync(usuario)



        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      console.log("Erro ao atualizar usuário", error)
      setLoading(false)
    }
  }

  return (
    <Container className={classes.container}>
      <div className={classes.root}>
        <div className={classes.content}>
          {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
          <Typography variant="h4" className={'title'}>
            Scouting Pool
          </Typography>

          {loading ? (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          ) : null}

          <Box sx={{ width: '100%', minHeight: 150, }} style={{ alignSelf: 'center', paddingTop: 10, paddingBottom: 10, }}>

            <Typography style={{ margin: 5 }} ref={myRef} component={'h2'}  >
              Paste a link to the job listing (with job description)
            </Typography>
            <TextField
              style={{ maxWidth: "500px" }}
              label="Paste the link here"
              value={joblink}
              onChange={(e) => setJoblink(e.target.value)}

              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LinkIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <Tooltip title="Paste link">
                      <IconButton
                        size="small"
                        onClick={async () => {
                          try {
                            const text = await navigator.clipboard.readText();
                            setJoblink(text);
                          } catch (err) {
                            console.error('Failed to read clipboard contents: ', err);
                          }
                        }}
                      >
                        <Assignment />
                      </IconButton>
                    </Tooltip>
                    {selectedKeywords && (
                      <IconButton size="small" onClick={() => setJoblink('')}>
                        <ClearIcon />
                      </IconButton>
                    )}
                  </InputAdornment>
                )
              }}
            />
            <Button onClick={() => {
              if (joblink)
                sendMessage()
            }}>Search</Button>


            {
              urlResult?.jobtitle ?
                <Box sx={{ width: '100%', height: 50, }} style={{ alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                  <Button onClick={() => {
                    if (joblink)
                      setShowJob(true)
                  }}>{`${urlResult?.jobtitle} at ${urlResult.company}`}</Button>
                </Box>
                : null
            }

          </Box>

          <Box sx={{ width: '100%', mb: 2 }} style={{ alignSelf: 'center', paddingTop: 5, paddingBottom: 5, }}>
            <Stack spacing={1} direction="column" alignItems={'center'} alignContent={'center'}>
              <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'center', justifyContent: 'center', gap: 2 }}>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Autocomplete
                    getOptionLabel={(cat: any) => getCategoriaNome(cat.name)}
                    //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                    onChange={(event, newValue) => {
                      console.log('newValue ==> ', newValue)
                      setSelectedCategory(newValue)
                      if (!newValue) {

                        return
                      }

                    }}
                    disablePortal
                    id="combo-box-demo"
                    options={categories}
                    sx={{ width: 250 }}
                    renderInput={(params: any) => <TextField {...params} size="small" label="Category" />}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Select the category of your interest" arrow>
                    <IconButton size="small" aria-label="settings">
                      <HelpIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Autocomplete
                    getOptionLabel={(usu: any) => usu.name}
                    //value={{name : editUsuarioData.location}}
                    //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                    onChange={(event, newValue) => {
                      console.log('selectedLocation', newValue)

                      if (newValue?.name) {
                        setSelectedLocation(newValue)
                        //setUserCategory(newValue)
                        //changeFilter()
                      } else {
                        setSelectedLocation({})
                        //setUserCategory({})
                        //changeFilter()
                      }


                    }}
                    disablePortal
                    id="combo-box-usuario"
                    options={allCountries}
                    sx={{ width: 250 }}
                    renderInput={(params: any) => <TextField {...params} size="small" label="Location" />}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Select the location of your interest" arrow>
                    <IconButton size="small" aria-label="settings">
                      <HelpIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Autocomplete
                    options={[9, 8, 7, 6, 5, 4, 3, 2, 1, 0]}
                    getOptionLabel={(option) => `Score ${option}+`}
                    onChange={(event, newValue) => {
                      setSelectedGrade(newValue);
                    }}
                    disablePortal
                    id="combo-box-grade"
                    sx={{ width: 220 }}
                    renderInput={(params: any) => <TextField {...params} size="small" label="Minimum Score" />}
                  />
                  <Tooltip TransitionComponent={Zoom} title="Filter by minimum score" arrow>
                    <IconButton size="small" aria-label="settings">
                      <HelpIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Stack>
          </Box>
          <Box sx={{ width: '100%', maxWidth: '100%', marginBottom: 5 }}>

            <TextField
              style={{ marginBottom: 5, maxWidth: 350 }}
              variant="outlined"
              hiddenLabel
              label="type a word of interest to you"

              maxRows={1}
              value={selectedKeywords}
              onChange={(e) => {
                setSelectedKeywords(e.target.value)

              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && selectedKeywords) {
                  getUsersAsync()
                }
              }}
              InputProps={{
                endAdornment: selectedKeywords ? (
                  <IconButton size="small" onClick={() => setSelectedKeywords('')}>
                    <ClearIcon />
                  </IconButton>
                ) : undefined
              }}
            />
            <Tooltip TransitionComponent={Zoom} title="type a word of interest to you" arrow>
              <IconButton aria-label="settings">
                <HelpIcon />
              </IconButton>
            </Tooltip>
            <Button onClick={() => {
              if (selectedKeywords)
                getUsersAsync()
            }}>Search</Button>

            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyFavorites}
                    onChange={(e) => setShowOnlyFavorites(e.target.checked)}
                    color="secondary"
                  />
                }
                label="Favorites Only"
              />
            </Box>

          </Box>
          {/*   {rows.length ? (
            <Box sx={{  width: '100%' }}>
              
            <DataGrid
              apiRef={apiRef}
              loading={isLoadingInventory}
              getRowId={(row: { _id: any; }) => row._id}
              //checkboxSelection
          disableRowSelectionOnClick
          
          onClipboardCopy={(copiedString) => console.log(copiedString)}
          unstable_ignoreValueFormatterDuringExport
              autoHeight={true}
              rows={rows}
              columns={columns}
              initialState={{
                sorting: {
                  sortModel: [{ field: 'createdAt', sort: 'desc' }],
                },
                
                pagination: {
                  paginationModel: {
                    pageSize: 15,
                  },
                },
              }}
              pageSizeOptions={[5]}
              //checkboxSelection
              
              //editMode="row"
              rowModesModel={rowModesModel}
              onRowModesModelChange={handleRowModesModelChange}
              onRowEditStop={handleRowEditStop}
              processRowUpdate={processRowUpdate}
              // slots={{
              //   toolbar: EditToolbar,
              // }}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: { setRows, setRowModesModel,csvOptions:{
                  fileName: 'inventariosDataBase_',
                  delimiter: ';',
                  utf8WithBom: true,
                },
                columns: {
                  columnVisibilityModel:{ID: false,},
                },
                columnsPanel: {
                  getTogglableColumns,
                },
                printOptions: {hideToolbar:true, disableToolbarButton: false }},
              }}

              
       
              //toolbar: { printOptions: { getRowsToExport: getSelectedRowsToExport } },
        
        
            />
              
          </Box>
          ):(<div style={{margin:15}}>
            not found
          </div>)} */}


          {Array.isArray(users) && users.length ? (
            <div className={classes.listContainer}>

              {users
                .filter((user: any) => !showOnlyFavorites || favorites.includes(user._id))
                .map((user: any, index: any) => (
                  <Card className={classes.card} key={index}>
                    <CardHeader
                      avatar={
                        <Avatar sx={{ bgcolor: '#0df228' }} aria-label="recipe">
                          {user.name.substring(0, 2)}
                        </Avatar>
                      }
                      title={user.name}
                      subheader={
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span>{user.grade ? 'score: ' + user.grade : ' '}</span>
                          {user.grade ? (
                            <Tooltip title="AI Resume Feedback" placement="top">
                              <IconButton size="small" onClick={() => handleOpenAiFeedback(user)}>
                                <AutoAwesomeIcon style={{ color: '#00FFFF' }} fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          ) : null}
                        </div>
                      }
                      titleTypographyProps={{ style: { userSelect: 'none' } }}
                      subheaderTypographyProps={{ style: { userSelect: 'none' } }}
                      action={
                        <IconButton
                          aria-label="add to favorites"
                          onClick={() => handleToggleFavorite(user._id)}
                          color="secondary"
                        >
                          {favorites.includes(user._id) ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                        </IconButton>
                      }
                    />
                    <CardMedia
                      style={{ backgroundColor: 'white' }}
                      component="img"
                      height="194"
                      image={user.image ? serverConfig.dev.url + 'images/' + user.image : "https://robohash.org/" + user.name}
                      alt="User image"
                    />
                    <CardContent className={classes.cardContent} style={{ backgroundColor: 'white' }}>
                      {
                        usuario.role === 'scouter' || usuario.role === 'admin' ?
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body2" align="center" style={{ userSelect: 'none' }}>
                              Invite this scout to be referred
                            </Typography>

                            <Button size="small" variant="outlined" className={classes.irButton} onClick={() => {
                              handleAddRecommendationPanel(user)
                            }}>Invite</Button>
                          </Box> :
                          null
                      }
                    </CardContent>
                    <CardActions disableSpacing>
                      <Button variant='contained' size="small" className={classes.irButton} onClick={() => {
                        handleScoutInfo(user)
                      }}>Professional info</Button>

                      {
                        usuario.role === 'scouter' || usuario.role === 'admin' ?
                          <ExpandMore
                            expand={expanded == user._id ? true : false}
                            onClick={() => { handleExpandClick(user._id) }}
                            aria-expanded={expanded == user._id}
                            aria-label="show more"
                          >
                            <ExpandMoreIcon />
                          </ExpandMore>
                          : null
                      }
                    </CardActions>
                    <Collapse in={expanded == user._id} timeout="auto" unmountOnExit>
                      <CardContent>
                        <Typography paragraph style={{ userSelect: 'none' }}>
                          Invite this scout to be referred
                        </Typography>
                        <Typography paragraph>
                          <Button className={classes.irButton} onClick={() => {
                            handleAddRecommendationPanel(user)
                          }}>Invite</Button>
                        </Typography>
                      </CardContent>
                    </Collapse>
                  </Card>
                ))}

            </div>

          ) : <Box>
            <Typography paragraph>
              No results were found based on your search.
            </Typography>
          </Box>}
          <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
        </div>
      </div>

      <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)}>
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Tem certeza de que deseja excluir?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteConfirmationOpen(false)}>Cancel</Button>
          <Button onClick={handleDeleteConfirmation} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openModalRecomendation} onClose={() => setOpenModalRecomendation(false)}>
        <DialogTitle>Attach some infos to invite {selectedScout.name}</DialogTitle>
        <DialogContent>
          {/* <Typography variant="body1">Write your message</Typography> */}

          <Typography component={'h3'} >
            Paste a link to the job listing (with job description) by: {usuario?.company?.name || ''}
          </Typography>
          <TextField
            style={{ maxWidth: "500px" }}
            label="Paste the link here"
            value={joblink}
            onChange={(e) => setJoblink(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Link />
                </InputAdornment>
              ),
            }}
          /* error={!validateEmail(editUsuarioData.email)}
          helperText={!validateEmail(editUsuarioData.email) && 'E-mail inválido'} */
          />


          <div style={{ fontSize: 18, }}>

            <TextField
              style={{ marginBottom: 5 }}
              variant="outlined"
              hiddenLabel
              label="Write your message"
              multiline
              maxRows={4}
              value={messageToScout || ""}
              onChange={(e) => setMessageToScout(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setOpenModalRecomendation(false)}>Cancel</Button>
          <Button variant='contained' onClick={() => handleAddRecommendation()} color="secondary">
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Modal open={scoutInfo} onClose={() => handlerCloseModal()} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        <div style={{
          backgroundColor: '#0a0a0a',
          color: '#ffffff',
          width: isMobile ? '95%' : '85%',
          maxWidth: '1100px',
          maxHeight: '90vh',
          borderRadius: '16px',
          border: '1px solid rgba(138, 46, 226, 0.3)',
          boxShadow: '0 8px 32px 0 rgba(0, 255, 255, 0.15)',
          display: 'flex',
          flexDirection: 'column',
          outline: 'none',
          fontFamily: '"Outfit", "Inter", sans-serif',
          overflow: 'hidden'
        }}>
          {/* Modal Header */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
            backgroundColor: '#111115'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <Avatar
                src={image || selectedScout?.avatar || (selectedScout?.name ? "https://robohash.org/" + selectedScout.name : "https://robohash.org/avatar")}
                style={{ width: '48px', height: '48px', border: '2px solid #00FFFF', boxShadow: '0 0 10px rgba(0, 255, 255, 0.3)' }}
              />
              <div style={{ textAlign: 'left' }}>
                <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#ffffff' }}>
                  {selectedScout?.name || "Unknown Scout"}
                </h2>
                <span style={{ fontSize: '14px', color: '#00FFFF', fontWeight: 500 }}>
                  {editUsuarioData.professionalTitle || 'No Title'}
                </span>
              </div>
            </div>
            <Button
              onClick={() => handlerCloseModal()}
              style={{
                color: '#ffffff',
                borderColor: 'rgba(255,255,255,0.3)',
                backgroundColor: 'rgba(255,255,255,0.05)',
                padding: '6px 16px',
                textTransform: 'uppercase',
                fontWeight: 600,
                fontSize: '12px'
              }}
              variant="outlined"
            >
              Close
            </Button>
          </div>

          {/* Modal Content - Scrollable */}
          <div style={{
            padding: '24px',
            overflowY: 'auto',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            backgroundColor: '#0a0a0a'
          }}>
            {/* Dynamic Two-Column Layout */}
            <div style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: '24px',
              width: '100%',
              alignItems: 'stretch'
            }}>
              {/* Left Column: Personal and Professional Info */}
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Professional Details Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 16px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Candidate Details
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Nowdays Location</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.location || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Origin Location</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{selectedScout.country || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>Years of Experience</span>
                      <span style={{ color: '#ffffff', fontWeight: 500 }}>{editUsuarioData.yearsOfExperience ? `${editUsuarioData.yearsOfExperience} years` : 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: '8px' }}>
                      <span style={{ color: '#a0a0ab', fontSize: '14px' }}>English Level</span>
                      <span style={{ color: '#00FFFF', border: '1px solid #00FFFF', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>{selectedScout.englishLevel || 'N/A'}</span>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                      {selectedScout.employed ? (
                        <span style={{ color: '#FF00FF', backgroundColor: 'rgba(255, 0, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FF00FF', fontSize: '12px', fontWeight: 600 }}>Employed</span>
                      ) : (
                        <span style={{ color: '#39FF14', backgroundColor: 'rgba(57, 255, 20, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #39FF14', fontSize: '12px', fontWeight: 600 }}>Open to Hire</span>
                      )}
                      {selectedScout.opentorelocation && (
                        <span style={{ color: '#00FFFF', backgroundColor: 'rgba(0, 255, 255, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #00FFFF', fontSize: '12px', fontWeight: 600 }}>Open to Relocate</span>
                      )}
                      {selectedScout.uePassport && (
                        <span style={{ color: '#FFFF00', backgroundColor: 'rgba(255, 255, 0, 0.1)', padding: '2px 8px', borderRadius: '4px', border: '1px solid #FFFF00', fontSize: '12px', fontWeight: 600 }}>UE Passport</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Bio Summary Section */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 12px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Bio / Professional Summary
                  </h3>
                  <p style={{
                    margin: 0,
                    color: '#e4e4e7',
                    fontSize: '14px',
                    lineHeight: '1.6',
                    whiteSpace: 'pre-wrap'
                  }}>
                    {editUsuarioData.bio || 'No bio summary provided by the candidate.'}
                  </p>
                </div>

                {/* Experience & Education Details */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}>
                  <div>
                    <h3 style={{ margin: '0 0 8px 0', color: '#8A2BE2', fontSize: '16px', fontWeight: 600 }}>Education Background</h3>
                    <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                      {editUsuarioData.educationBackground || 'No education background listed.'}
                    </p>
                  </div>
                  <div style={{ borderTop: '1px solid rgba(255, 255, 255, 0.05)', paddingTop: '12px' }}>
                    <h3 style={{ margin: '0 0 8px 0', color: '#8A2BE2', fontSize: '16px', fontWeight: 600 }}>Experience Description</h3>
                    <p style={{ margin: 0, color: '#e4e4e7', fontSize: '14px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
                      {editUsuarioData.description || 'No detailed experience listed.'}
                    </p>
                  </div>
                </div>

                {/* Curriculum PDF */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '20px',
                  border: '1px solid rgba(138, 46, 226, 0.15)',
                  textAlign: 'left'
                }}>
                  <h3 style={{ margin: '0 0 12px 0', color: '#8A2BE2', fontSize: '18px', fontWeight: 600, borderBottom: '1px solid rgba(138, 46, 226, 0.2)', paddingBottom: '8px' }}>
                    Curriculum Document
                  </h3>
                  {(defaultPdf || editUsuarioData.pdf) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <span style={{ fontSize: '13px', color: '#a0a0ab' }}>Uploaded CV: {defaultPdf || editUsuarioData.pdf}</span>
                      <Button
                        variant='contained'
                        onClick={() => setOpenPdf(true)}
                        style={{
                          background: 'linear-gradient(45deg, #8A2BE2, #00FFFF)',
                          color: '#ffffff',
                          fontWeight: 600,
                          textTransform: 'none'
                        }}
                      >
                        Open Curriculum Viewer
                      </Button>
                    </div>
                  ) : (
                    <span style={{ fontSize: '14px', color: '#a0a0ab' }}>No resume PDF uploaded.</span>
                  )}
                </div>
              </div>

              {/* Right Column: AI Resume Feedback Analysis (Favorite) */}
              <div style={{
                flex: 1.2,
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}>
                {/* Favorite AI Feedback Card */}
                <div style={{
                  backgroundColor: '#111115',
                  borderRadius: '12px',
                  padding: '24px',
                  border: '1px solid rgba(0, 255, 255, 0.3)',
                  boxShadow: '0 0 15px rgba(0, 255, 255, 0.05)',
                  textAlign: 'left',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%'
                }}>
                  {/* Header: AI Matching Feedback */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(0, 255, 255, 0.2)', paddingBottom: '12px', marginBottom: '16px' }}>
                    <div>
                      <h3 style={{ margin: 0, color: '#00FFFF', fontSize: '18px', fontWeight: 600 }}>
                        AI Match Analysis
                      </h3>
                      <span style={{ fontSize: '12px', color: '#39FF14', fontWeight: 600, textTransform: 'uppercase', display: 'block', marginTop: '2px' }}>
                        ★ Starred Feedback
                      </span>
                    </div>

                    {/* Animated/Glowing Matching Circular Score */}
                    {limit ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CircularProgressWithLabel
                          value={progress}
                          size={50}
                          style={{ color: '#39FF14' }}
                        />
                        <span style={{ fontSize: '12px', color: '#a0a0ab', fontWeight: 500 }}>Compatibility Score</span>
                      </div>
                    ) : null}
                  </div>

                  {/* AI Target Job Context */}
                  {airesumefeedbackData?.job && (
                    <div style={{
                      marginBottom: '16px',
                      padding: '10px 14px',
                      borderRadius: '8px',
                      backgroundColor: 'rgba(255, 255, 255, 0.03)',
                      borderLeft: '3px solid #FF00FF',
                      fontSize: '13px',
                      color: '#e4e4e7'
                    }}>
                      <strong style={{ color: '#FF00FF' }}>Target Job Description:</strong>{' '}
                      {airesumefeedbackData.job.length > 150 ? `${airesumefeedbackData.job.substring(0, 150)}...` : airesumefeedbackData.job}
                    </div>
                  )}

                  {/* Formatted Response Body */}
                  <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '520px',
                    paddingRight: '8px',
                    fontSize: '14px',
                    color: '#e4e4e7',
                    lineHeight: '1.6'
                  }} className="custom-scrollbar">
                    {finalResult ? (
                      <div dangerouslySetInnerHTML={{ __html: finalResult }} />
                    ) : (
                      <div style={{ color: '#a0a0ab', textAlign: 'center', padding: '40px 0' }}>
                        No starred AI Resume Feedback available for this profile.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal className={'modalContent'} open={openAiFeedbackModal} onClose={() => setOpenAiFeedbackModal(false)}   >
        <div style={{ margin: 0, backgroundColor: 'white', width: screenWidth }} className={'modalContent'}>
          <Button className='backbutton' onClick={() => setOpenAiFeedbackModal(false)}>Close</Button>

          <div className={classes.listContainer}>
            <div style={{ margin: 15, width: '100%', maxWidth: '800px', alignSelf: 'center' }}>
              <span className="user-detail text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography variant="h4" style={{ fontWeight: 'bold', marginTop: '5px' }}>{selectedScout?.name}</Typography>
                <Typography variant="h6" style={{ color: '#00FFFF', fontWeight: 'bold' }}>
                  <AutoAwesomeIcon style={{ verticalAlign: 'middle', marginRight: 5 }} />
                  AI Resume Analysis
                </Typography>
              </span>

              {airesumefeedbackData?.job && (
                <Box style={{ padding: '12px 16px', backgroundColor: '#f5f5f5', borderRadius: '8px', marginTop: '10px', border: '1px solid #e0e0e0', width: '100%' }}>
                  <Typography variant="caption" style={{ fontWeight: 600, display: 'block', color: '#666', marginBottom: '4px' }}>
                    Job Interpretation:
                  </Typography>
                  <Typography variant="body1" style={{ fontWeight: 500, color: '#1976d2' }}>
                    {airesumefeedbackData.job}
                  </Typography>
                </Box>
              )}

              {limit ? (
                <Stack style={{ width: '100%', textAlign: 'center' }} spacing={2} margin={2} direction="column" justifyContent={'center'}>
                  <Typography variant="h6">Match Score</Typography>
                  <div>
                    <CircularProgressWithLabel style={{ margin: 5, color: '#00FFFF' }} value={progress} size={60} />
                  </div>
                </Stack>)
                : null}

              <Stack spacing={2} style={{ width: '100%', textAlign: 'center', marginBottom: 20 }}>
                {(defaultPdf || editUsuarioData?.pdf) ?
                  <div style={{ color: 'black' }}>
                    <Button variant='contained' style={{ backgroundColor: '#00FFFF', color: 'black', fontWeight: 'bold' }} onClick={() => setOpenPdf(true)}>
                      <AssessmentIcon style={{ marginRight: 8 }} /> Visualize PDF Curriculum
                    </Button>
                  </div>
                  : null}
              </Stack>

              <Divider />

              {
                finalResult ? (
                  <Stack borderRadius={15} spacing={2} direction="column" alignItems={'center'} alignContent={'center'}>
                    <div id="chatbox" className='chatbox' style={{ width: '100%' }}>
                      <div dangerouslySetInnerHTML={{ __html: finalResult }} style={{ width: '100%', maxWidth: '800px', fontSize: '16px!important', color: '#2F2F33!important', height: '400px', padding: '15px', fontFamily: 'Montserrat', textAlign: 'justify', margin: '0 auto', overflowY: 'scroll', backgroundColor: '#f9f9f9', borderRadius: '8px', border: '1px solid #ddd' }}>
                      </div>
                    </div>
                  </Stack>
                ) : <Box p={4} textAlign="center"><CircularProgress style={{ color: '#00FFFF' }} /></Box>
              }
            </div>
          </div>
        </div>
      </Modal>


      <Modal className={'modalContent'} open={openPdf} onClose={() => setOpenPdf(false)}   >
        <div style={{ margin: 0, backgroundColor: 'white', width: screenWidth }} className={'modalContent'}>

          <Button className='backbutton' onClick={() => setOpenPdf(false)}>Close</Button>




          <Worker workerUrl={workerUrl}>
            <Viewer
              fileUrl={serverConfig.dev.url + 'images/pdf/' + (defaultPdf || editUsuarioData.pdf)}
              plugins={[
                // Register plugins
                defaultLayoutPluginInstance,
              ]}

            />
          </Worker>


        </div>
      </Modal>






      <Modal className={'modalContent'} open={showJob} onClose={() => setShowJob(false)}>
        <div style={{ margin: '0 auto!important', backgroundColor: 'white', width: screenWidth }} className={'modalContent'}>

          <Button className='backbutton' onClick={() => setShowJob(false)}>Close</Button>

          <Box sx={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
            <TextField
              type="text"
              value={urlResult.company}
              label="Company"
            //onChange={(e) => setEditUsuarioData({ ...urlResult, nome: e.target.value })}
            />

            <TextField
              type="text"
              value={urlResult.jobtitle}

            />
            <TextField
              type="text"
              value={urlResult.resume}
              multiline
              maxRows={4}
            />
            {
              urlResult.others ?
                <TextField
                  type="text"
                  value={urlResult.others}
                  multiline
                  maxRows={4}
                />
                : null
            }
            {
              urlResult.benefits ?
                <TextField
                  type="text"
                  value={urlResult.benefits}
                  multiline
                  maxRows={4}
                />
                : null
            }
            <TextField
              type="text"
              value={urlResult.location}

            />
            <TextField
              type="text"
              value={urlResult.type}

            />
          </Box>
        </div>
      </Modal>
    </Container>
  );
};


// ... other imports

const mapStateToProps = (state: any) => ({
  usuario: state.user.user,
});

const mapDispatchToProps = {
  setUser
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ScoutingPoolPage);


